module.exports = __webpack_public_path__ + "img/A.ebb55853.png";